import "twin.macro";

import { useSelector } from "react-redux";

import { StyledButton } from "@components/StyledComponents";
import useConfirm from "@features/confirm";
import { BlockCard, Type } from "@features/ui";
import { User } from "@models/User";

import { useRemoveMultiOrgUserFromOrgMutation } from "../data";
import useNavigateToUser from "../useNavigateToUser";

const LabelValuePair = ({ label, value }: { label: string; value: string }) => (
  <div tw="">
    <div tw="text-neutral-700 text-sm tracking-wide">{label}</div>
    <div tw="text-neutral-800 text-lg">{value}</div>
  </div>
);

const ReadOnlyUserForm = ({ user }: { user: User }) => {
  const confirm = useConfirm();
  const navigateToUser = useNavigateToUser();
  const removeMultiOrgUserMutation = useRemoveMultiOrgUserFromOrgMutation();
  const orgBrands = useSelector(
    (state: any) => state.currentUser.organization.brands
  );
  const userLimitedBrands = user.limitedBrands.filter((b) =>
    orgBrands.some((orgBrand: any) => orgBrand.id === b.id)
  );

  const userType = user.supplier ? "supplier" : "distributor";

  const handleRemoveUser = async () => {
    if (
      await confirm(`Are you sure you want to remove this ${userType} user?`)
    ) {
      removeMultiOrgUserMutation.mutate(user, {
        onSuccess: () => navigateToUser(null),
      });
    }
  };

  return (
    <>
      <BlockCard tw="space-y-4">
        <div tw="rounded-md bg-neutral-50 p-4 -mx-2 text-neutral-600 border border-neutral-200">
          <p>
            This {userType} user is managed by the brandhub team. To request any
            changes, please contact support.
          </p>
        </div>
        <LabelValuePair label="Name" value={user.name} />
        <LabelValuePair label="Email" value={user.email} />
        {user.supplier && (
          <LabelValuePair label="Supplier" value={user.supplier.name} />
        )}
        {user.distributorName && (
          <>
            <div tw="flex items-end justify-between">
              <LabelValuePair
                label="Distributor"
                value={user.distributorName}
              />
              <Type.Link to={`/admin/distributors/${user.distributorId}`}>
                Manage Distributor
              </Type.Link>
            </div>
            <LabelValuePair
              label="Limited Brands"
              value={userLimitedBrands.map((b) => b.name).join(", ") || "None"}
            />
          </>
        )}
      </BlockCard>
      <StyledButton tw="float-right mt-3" onClick={handleRemoveUser} danger>
        Remove access
      </StyledButton>
    </>
  );
};

export default ReadOnlyUserForm;
